export default {
  dot: "dot",
  square: "square"
} as CornerDotTypes;
